import { slugs } from '@/constants/slugs'

// Pay It Forward (PIF) related constants

// Minimum USD amount to unlock the "Your Name in the Credits" perk

export const PIF_NAME_IN_CREDITS_MIN_USD = 500

export const PIF_NAME_IN_CREDITS_MIN_TICKETS = 35

// Name in Credits date range for young-washington
const NAME_IN_CREDITS_START_YOUNG_WASHINGTON = new Date('2026-01-22T12:00:00Z')
const NAME_IN_CREDITS_END_YOUNG_WASHINGTON = new Date('2026-05-20T06:59:00Z')

interface PifNameInCreditsOptions {
  forceEnable?: boolean
}

export function isPifNameInCreditsEnabled(projectSlug: string, options?: PifNameInCreditsOptions): boolean {
  const now = new Date()

  if (now >= NAME_IN_CREDITS_END_YOUNG_WASHINGTON) {
    return false
  }
  if (options?.forceEnable) {
    return projectSlug === slugs.youngWashington
  }
  return projectSlug === slugs.youngWashington && now >= NAME_IN_CREDITS_START_YOUNG_WASHINGTON
}

// David trailer video URL and thumbnail
export const DAVID_TRAILER_URL =
  'https://www.youtube-nocookie.com/embed/Sr6OUtx6ZyQ?autoplay=1&playsinline=1&rel=0&modestbranding=1'
export const DAVID_TRAILER_THUMBNAIL =
  'https://images.angelstudios.com/image/upload/v1761150935/theatrical/david/david-1m-promo-img-philc-placeholder'
